import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    forwardRef,
    HostBinding,
    HostListener,
    inject,
    Input,
    input,
    model,
    output,
    signal,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    ControlContainer,
    FormGroupDirective,
    AbstractControl,
    ValidationErrors,
    ControlValueAccessor,
    Validator,
    NG_VALIDATORS
} from '@angular/forms';
import { Store } from '@ngxs/store';
// import {
//   CustomerType,
//   CustomerGraphQLSchemaSelectors,
//   CustomerGraphQLSchemaActions,
//   CustomerTypeQuery,
//   ProductGraphQLSchemaSelectors,
//   ProductPackageGraphQLSchemaSelectors,
//   ProductPackageGraphQLSchemaActions,
//   ProductPackageTypeQuery,
//   ProductPackageType,
//   ProductUnitTypeTypeQuery,
//   ProductInvoicingInfoTypeQuery,
//   VATCategoryTypeQuery,
//   ProductToDiscount,
//   ProductToDiscountTypeQuery,
//   ProductInventoryInfoTypeQuery,
//   DiscountCategoryTypeQuery,
// } from '../../../zigra-schemas/auto-generated-schemas/zigra-schema.autogenerated.models';
import { ZSelectComponent } from '../../form-components/z-select/z-select.component';

import { SelectFilterEvent } from 'primeng/select';
import { LazyLoadEvent, ToastMessageOptions } from 'primeng/api';
import { ZAutoCompleteComponent } from '../../form-components/z-auto-complete/z-auto-complete.component';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { OverlayModule } from 'primeng/overlay';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ZTableVSSelectComponent } from '../../form-components/z-table-select/z-table-virtual-scroller-select.component';
// import {
//   DataTableColumn,
//   DataTableFactory,
//   DataTableSchema,
//   IDataTableSelectedRow,
// } from '../../../zigra-components/z-data-table/shemas/data-table-schema';

import {
    FetchQueryFilterGroup,
    FetchQuerySortInfo,
    ObjectId,
    QueryFilter,
    QueryFilterGroup
} from 'zigra-ng-framework';
import { concatMap, finalize, map, of, timer } from 'rxjs';
import { ZTableVSSearchComponent } from '../../form-components/z-table-search/z-table-virtual-scroller-search.component';

// import { UniqIDsGeneratorService } from '../../../services/unique-ids-generator.service';
// import { GraphQLQueryBuilderService } from '../../../services/graphql-query-builder.service';
// import { NoAction } from '../../../zigra-schemas/custom/no-action';
// import { ProductFormComponent } from '../../../../app/portal/products/components/product-form/product-form/product-form.component';
// import { EntityFormModeType } from '../../../zigra-types/entity-form-mode.type';

import { DialogModule } from 'primeng/dialog';
import {
    CustomerTypeQuery,
    DiscountCategoryTypeQuery,
    InvoiceDetailType,
    ProductDepartmentTypeQuery,
    ProductInventoryInfoTypeQuery,
    ProductInvoicingInfoTypeQuery,
    ProductPackageGraphQLSchemaActions,
    ProductPackageGraphQLSchemaSelectors,
    ProductPackageType,
    ProductPackageTypeQuery,
    ProductToDiscountTypeQuery,
    ProductUnitTypeTypeQuery,
    VATCategoryTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import {
    IDataTableSelectedRow,
    DataTableSchema,
    DataTableFactory,
    DataTableColumn
} from '@shared/components/form-components/helpers/data-table-schema';
import { GraphQLQueryBuilderService } from '@shared/services/graphql-query-builder.service';
import { UniqIDsGeneratorService } from '@shared/services/unique-ids-generator.service';
import {
    EntityFormModeEnum,
    EntityFormModeType
} from '@shared/types/entity-form-mode.type';
import { NoAction } from '@shared/zigra-schemas/custom/no-action';
import { ButtonModule } from 'primeng/button';
// import { EntityFormModeEnum } from '@shared/types/dialog-mode.type';
import { ZProductEditComponent } from '../z-product-edit/z-product-edit.component';
import { LoaderService } from '@shared/services/loader.service';
import { ZionMessagesService } from '@shared/services/ax-messages.service';

@Component({
    selector: 'z-product-select',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        OverlayModule,
        ButtonModule,
        DialogModule,
        TableModule,
        InputTextModule,
        ZTableVSSelectComponent,
        ZTableVSSearchComponent,
        ZProductEditComponent
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZProductSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZProductSelectComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './z-product-select.component.html',
    styleUrl: './z-product-select.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

//@ViewChild('productEditComponent') productEditComponent?: ZProductEditComponent;
export class ZProductSelectComponent
    implements ControlValueAccessor, Validator
{
    @ViewChild('productEditComponent')
    productEditComponent?: ZProductEditComponent;
    @ViewChild('ZTableVSSearch') ZTableVSSearch?: ZTableVSSearchComponent;
    @HostBinding('class') class?: string = 'flex grow';
    @Input() index?: number;

    mode = model<'edit' | 'view' | 'search' | 'lockedit'>('view');
    label = input<string | undefined>('Είδος');
    autocomplete = input<string | undefined>(undefined);
    doNotSetModelOnRowDataSelect = input<boolean | undefined>(undefined);
    id = input<string | undefined>(undefined);
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('_id');
    productPackageId = input<ObjectId | undefined>(undefined);
    productPackage = input<ProductPackageType | undefined>(undefined);
    kind = input<string | undefined>(undefined);
    doNotExpandOptionsOnInputFocus = input<boolean | undefined>(undefined);
    inputMode = input<'code' | 'descr'>('code');
    existingIds = input<any[] | undefined>(undefined);
    options = model<ProductPackageType[] | undefined>(undefined);
    scrollHeight = input<string>('600px');
    invoiceTypeCode = input<string | undefined>();

    rowDataSelect = output<{
        productPackage?: ProductPackageType;
        rowIndex: number;
    }>();
    inputFocus = output<number>();
    inputBlur = output<number>();

    selectedOption = signal<
        IDataTableSelectedRow<ProductPackageType> | undefined
    >(undefined);
    placeholder = input<string | undefined>(undefined);
    store = inject(Store);
    loaderService = inject(LoaderService);
    messageService = inject(ZionMessagesService);
    cd = inject(ChangeDetectorRef);

    fetchDataForEditById = signal<
        | { formModeType: EntityFormModeType; productPackageId?: ObjectId }
        | undefined
    >(undefined);

    // protected selectedProductPackage = signal<ProductPackageType | undefined>(
    //   undefined,
    // );
    protected dataTableSchema = signal<DataTableSchema | undefined>(undefined);
    protected totalRecords = signal<number>(0);
    protected productVisibleDialog: boolean = false;
    protected productDialogMode?: EntityFormModeType;
    private _searchTerm?: string;
    private instanceId: string = '';

    constructor(
        private uniqIDsGeneratorService: UniqIDsGeneratorService,
        private graphQLQueryBuilderService: GraphQLQueryBuilderService
    ) {
        this.instanceId = uniqIDsGeneratorService.getNextUniqueId().toString();

        // const schema = [
        //         DataTableColumn.StringColumn('Title', 'Περιγραφή', {
        //             searchable: true
        //         }),
        //         DataTableColumn.StringColumn('Code', 'Κωδικός', {
        //             searchable: true
        //         }),
        //         DataTableColumn.StringColumn('Kind', 'Κατηγορία', {
        //             searchable: false
        //         }),
        //         // DataTableColumn.StringColumn(
        //         //     'InventoriesList[0].SmallPackageItems',
        //         //     'Ποσότητα', //'Ποσότητα Συσκευασίας',
        //         //     {
        //         //         searchable: true
        //         //     }
        //         // ),
        //         DataTableColumn.StringColumn(
        //             'InventoriesList[0].StockAvail',
        //             'Διαθέσιμο Απόθεμα'
        //         )
        //     ];

        // this.dataTableSchema.set(
        //     DataTableFactory.AddDatatableSchema(schema)
        // );

        // this.store
        //   .select(
        //     ProductPackageGraphQLSchemaSelectors.FetchAndCountSelector(
        //       '',
        //       this.instanceId,
        //     ),
        //   )
        //   .pipe(takeUntilDestroyed())
        //   .subscribe((fetchResult) => {
        //     if (fetchResult?.data.FetchAndCount != undefined) {
        //       this.options.set(
        //         Array.from({ length: fetchResult?.data.FetchAndCount ?? 0 }),
        //       );
        //       this.totalRecords.set(fetchResult?.data.FetchAndCount ?? 0);
        //     }
        //   });

        // this.store
        //   .select(ProductPackageGraphQLSchemaSelectors.FetchSelector('', ''))
        //   .pipe(takeUntilDestroyed())
        //   .subscribe((fetchResult) => {
        //     this.selectedOption.update((option) => {
        //       if (option != undefined)
        //         option.data = fetchResult?.data?.Fetch?.find(
        //           (item) => item._id == this.model,
        //         );
        //       return option;
        //     });
        //   });
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }

    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnChanges(simpleChanges: SimpleChanges) {
        if (simpleChanges['productPackage']?.currentValue != undefined) {
            const productPackage = simpleChanges['productPackage']
                .currentValue as ProductPackageType;

            // θέλουμε αυτό το χαζό If γιατί από τη καρτέλα της γραμμής του παρστατικού περνάμε το  detail.get('ProductPackage')?.value
            // και επειδή παίζουμε με formGroup και αυτόματα creations των nested controls
            // αυτό έχει παντά τιμή γιατι το  detail.get('ProductPackage')?.value έχει τιμη σαν formGroup
            if (productPackage._id != undefined) {
                this.selectedOption.set({
                    index: 0,
                    data: productPackage,
                    searchterm: undefined
                } as IDataTableSelectedRow);
            }
        }

        if (simpleChanges['invoiceTypeCode']?.currentValue != undefined) {
            const schema = [
                DataTableColumn.StringColumn('Title', 'Περιγραφή', {
                    searchable: true
                }),
                DataTableColumn.StringColumn('Code', 'Κωδικός', {
                    searchable: true
                })
                // DataTableColumn.StringColumn('Kind', 'Κατηγορία', {
                //     searchable: false
                // })
                // DataTableColumn.StringColumn(
                //     'InventoriesList[0].SmallPackageItems',
                //     'Ποσότητα', //'Ποσότητα Συσκευασίας',
                //     {
                //         searchable: true
                //     }
                // ),
                // DataTableColumn.StringColumn(
                //     'InventoriesList[0].StockAvail',
                //     'Διαθέσιμο Απόθεμα'
                // )
            ];

            if (
                this.invoiceTypeCode() != '11.2' &&
                this.invoiceTypeCode() != '2.1'
            ) {
                schema.push(
                    DataTableColumn.StringColumn('Kind', 'Κατηγορία', {
                        searchable: false
                    })
                );

                schema.push(
                    DataTableColumn.StringColumn(
                        'InventoriesList[0].StockAvail',
                        'Διαθέσιμο Απόθεμα'
                    )
                );
            }
            this.dataTableSchema.set(
                DataTableFactory.AddDatatableSchema(schema)
            );
        }
    }

    ngOnInit() {
        // Initialize empty array of Options
        // this.options.set(Array.from({ length: 120 }));
        // this.totalRecords.set(120);
        // // On Init fetch the count of all to create the default options array
        // this.searchTermChange();
    }
    onLazyLoad($event: TableLazyLoadEvent) {
        this._searchTerm = $event.globalFilter as string | undefined;
        this.loadData($event);
    }
    onResetTable() {
        this.totalRecords.set(0);
    }

    searchTermChange(searchTerm?: string) {
        this.totalRecords.set(0);
        // this.model = searchTerm;
        // this.onModelChange(searchTerm);
    }

    loadData(event: TableLazyLoadEvent) {
        let groupQuery =
            this.graphQLQueryBuilderService.getGroupQueryForProductPackageType(
                this._searchTerm
            );

        // 11.2 : ΑΠΥ
        // 11.5 : Απόδειξη Λιανικής Πώλησης για Λογ/σμό Τρίτων
        // 1.1 : Τιμολόγιο Πώλησης
        // 2.1 : Τιμολόγιο Παροχής
        console.debug('invoiceTypeCode : ', this.invoiceTypeCode());
        const fetchOnlyServices =
            this.invoiceTypeCode() == '11.2' || this.invoiceTypeCode() == '2.1';

        if (fetchOnlyServices)
            groupQuery = QueryFilterGroup.JoinWithAndOperator([
                groupQuery,
                QueryFilterGroup.FieldIsEqualToBoolean<ProductPackageType>(
                    ['IsService'],
                    true
                )
            ]);

        console.debug('groupQuery', groupQuery);

        const fetch = new ProductPackageGraphQLSchemaActions.Fetch(
            ProductPackageTypeQuery.GQLQuery({
                ...ProductPackageTypeQuery.GQLQuery(),
                _id: true,
                Title: true,
                Code: true,
                BarCode: true,
                UnitTypeId: true,
                UnitType: ProductUnitTypeTypeQuery.GQLQuery({
                    _id: true,
                    Title: true
                }),
                Discounts: ProductToDiscountTypeQuery.GQLQuery({
                    DiscountCategoryId: true,
                    DiscountCategory: DiscountCategoryTypeQuery.GQLQuery({
                        Code: true
                    }),
                    ProductPackageId: true,
                    Perentage: true
                }),
                InventoriesList: ProductInventoryInfoTypeQuery.GQLQuery(),
                InvoicingList: ProductInvoicingInfoTypeQuery.GQLQuery({
                    WholesalePrice: true,
                    ProductPackageId: true,
                    VATCategoryId: true,
                    VATCategory: VATCategoryTypeQuery.GQLQuery({
                        _id: true,
                        Value: true
                    })
                }),
                ProductDepartment: ProductDepartmentTypeQuery.GQLQuery({
                    VATCategory: VATCategoryTypeQuery.GQLQuery()
                })
                // ProductPackage: ProductPackageTypeQuery.GQLQuery({
                //                       UnitType: ProductUnitTypeTypeQuery.GQLQuery(),
                //                       InvoicingList: ProductInvoicingInfoTypeQuery.GQLQuery({
                //                         VATCategory: VATCategoryTypeQuery.GQLQuery(),
                //                       }),
                //                     }),
                //                     ProductLOT: ProductLOTTypeQuery.GQLQuery(),
                //                     VATCategory: VATCategoryTypeQuery.GQLQuery(),
            }),
            {
                GroupQuery: groupQuery,
                SortQuery: [
                    {
                        Identifier: 'Title',
                        Order: 'ASC'
                    } as FetchQuerySortInfo
                ],
                Skip: event.first,
                Limit: event.rows ?? 100
            },
            '',
            this.instanceId
        );

        const fetchAndCount =
            new ProductPackageGraphQLSchemaActions.FetchAndCount(
                CustomerTypeQuery.GQLQuery(),
                {
                    GroupQuery: groupQuery
                },
                '',
                this.instanceId
                //QueryFilter.FetchQueryParamsFromAGGridParams({}),
            );

        this.store
            .dispatch([
                this.totalRecords() == 0 ? fetchAndCount : new NoAction(),
                (event.rows ?? 0) > 0 ? fetch : new NoAction()
            ])
            .subscribe(() => {
                if (this.totalRecords() == 0) {
                    const fetchAndCount = this.store.selectSnapshot(
                        ProductPackageGraphQLSchemaSelectors.FetchAndCountSelector(
                            '',
                            this.instanceId
                        )
                    );

                    // this.options.set(
                    //     Array.from({
                    //         length: fetchAndCount?.data.FetchAndCount ?? 0
                    //     })
                    // );
                    this.totalRecords.set(
                        fetchAndCount?.data.FetchAndCount ?? 0
                    );
                }

                this.options.set(
                    (
                        this.store.selectSnapshot(
                            ProductPackageGraphQLSchemaSelectors.FetchSelector(
                                '',
                                this.instanceId
                            )
                        )?.data.Fetch ?? []
                    ).map((productPackage) => {
                        return {
                            ...productPackage,
                            Kind: productPackage.ProductDepartment?.IsService //productPackage.IsService
                                ? 'Υπηρεσία'
                                : 'Ανταλλακτικό'
                        };
                    })
                );

                // const first = event.first ?? 0;
                // const rows = event.rows ?? 0;
                // this.options.update((options) => {
                //     const fetchData =
                //         this.store.selectSnapshot(
                //             ProductPackageGraphQLSchemaSelectors.FetchSelector(
                //                 '',
                //                 this.instanceId
                //             )
                //         )?.data.Fetch ?? [];
                //     Array.prototype.splice.apply(options, [
                //         first,
                //         rows,
                //         ...fetchData
                //     ]);

                //     return options;
                // });
                event.forceUpdate?.();
            });

        // if ((event.first ?? 0) == 0) {
        //   this._searchTerm = event.globalFilter as string;
        //   event.globalFilter = undefined;
        //   this.store
        //     .dispatch(fetchAndCount)
        //     .pipe(
        //       concatMap(() => {
        //         return this.store.dispatch(fetch);
        //       }),
        //     )
        //     .subscribe(() => {
        //       const first = event.first ?? 0;
        //       const rows = event.rows ?? 0;
        //       this.options.update((options) => {
        //         const fetchData =
        //           this.store.selectSnapshot(
        //             ProductPackageGraphQLSchemaSelectors.FetchSelector(
        //               '',
        //               this.instanceId,
        //             ),
        //           )?.data.Fetch ?? [];
        //         Array.prototype.splice.apply(options, [first, rows, ...fetchData]);

        //         return options;
        //       });
        //       event.forceUpdate?.();
        //     });
        // } else {
        //   this.store.dispatch(fetch).subscribe(() => {
        //     const first = event.first ?? 0;
        //     const rows = event.rows ?? 0;
        //     this.options.update((options) => {
        //       const fetchData =
        //         this.store.selectSnapshot(
        //           ProductPackageGraphQLSchemaSelectors.FetchSelector(
        //             '',
        //             this.instanceId,
        //           ),
        //         )?.data.Fetch ?? [];
        //       Array.prototype.splice.apply(options, [first, rows, ...fetchData]);

        //       return options;
        //     });
        //     event.forceUpdate?.();
        //   });
        // }
    }

    /**
     * Αυτό το onNgModelChange δεν είναι η αλλαγή από τον parent (δηλαδή π.χ το invocieCard -> detail row)
     * αλλά είναι η αλλαγή του μοντέλου του component z-table-vs-select, δηλαδή όταν ο χρήστης αναζητεί κάτι.
     * Σε αυτή την περίπτωση, που σημαίνει οτι ο χρήστης δεν θέλει κάτι από τη λίστα, αλλά γράφει κάτι δικό του,
     * θα πρέπει να ενημερώσουμε τον parent (δηλαδή π.χ το invocieCard -> detail row)
     * ότι έχεις αλλαγή στο μοντέλο σου (π.χ detail.Code) αλλά δεν έχει επιλεγεμένο ProductPackageId ούτε ProductPackage μοντέλο,
     * έχεις απλά έναν κωδικό που θα τον καταχωρήσεις στη βάση.
     * @param event
     */
    onNgModelChange(event: any) {
        this.onModelChange(event);

        this.rowDataSelect.emit({
            productPackage: undefined,
            rowIndex: this.index ?? 0
        });

        // // If productPackage is selected then do not modify model (that means to set the parent field 'Code' to the model value).
        // // If no productPackage is selected or If user input text is an empty then set model and emit to the client an empty productPackage object.
        // if (this.productPackageId() == undefined || event.trim() == '') {
        //     this.onModelChange(event);

        //     this.rowDataSelect.emit({
        //         productPackage: undefined,
        //         rowIndex: this.index ?? 0
        //     });
        // }
    }

    onRowDataSelect(selectedRow?: IDataTableSelectedRow<ProductPackageType>) {
        if (this.mode() != 'search' && this.mode() != 'lockedit') {
            this.mode.set('view');
        }

        this.model = selectedRow?.data?._id;

        this.selectedOption.set(selectedRow);
        this.onModelChange(this.model);

        // if (this.doNotSetModelOnRowDataSelect() != true) {
        //         this.model = selectedRow?.data?._id;
        //         this.onModelChange(this.model);
        //     }

        if (selectedRow?.data) {
            // if (this.doNotSetModelOnRowDataSelect() != true) {
            //     this.model = selectedRow?.data?._id;
            //     this.onModelChange(this.model);
            // }

            //this.selectedProductPackage.set(selectedRow?.data);
            this.fetchDataForEditById.set({
                formModeType: 'view',
                productPackageId: selectedRow?.data?._id
            });

            this.rowDataSelect.emit({
                productPackage: selectedRow?.data,
                rowIndex: this.index ?? 0
            });
        }
    }

    setFocus(resetOptions?: boolean) {
        if (resetOptions == true) this.options.set([]);
        this.ZTableVSSearch?.setFocus();
    }

    onInputDblClick() {
        // debugger;
        // const kk = this.productPackageId();
        // this.productVisibleDialog = true;
        // this.fetchDataForEditById.set({
        //     formModeType: 'view',
        //     productPackageId: this.productPackageId()
        // });
    }
    onInputFocus() {
        if (this.index != undefined) this.inputFocus.emit(this.index);
    }
    onInputBlur() {
        if (this.index != undefined) this.inputBlur.emit(this.index);
    }

    appendNewProductPackage(clickEvent: Event) {
        this.productDialogMode = EntityFormModeEnum.Add;
        this.productVisibleDialog = true;
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        this.cd.detectChanges();
        return false;
    }

    editProductPackage(clickEvent: Event) {
        this.productDialogMode = EntityFormModeEnum.Edit;
        this.productVisibleDialog = true;

        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        this.cd.detectChanges();
        return false;
    }

    saveProductPackage() {
        const productPackage = this.productEditComponent?.formGroup
            ?.value as ProductPackageType;

        this.loaderService.showAwaitDataSaveLoader();
        this.store
            .dispatch(
                new ProductPackageGraphQLSchemaActions.Upsert(
                    productPackage,
                    undefined,
                    productPackageQuery
                )
            )
            .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
            .subscribe(() => {
                const upsertProductPackage = this.store.selectSnapshot(
                    ProductPackageGraphQLSchemaSelectors.UpsertSelector
                );
                console.debug('saved Product Package: ', upsertProductPackage);

                this.messageService.add({
                    summary:
                        this.productDialogMode == 'add'
                            ? 'Νέα Καρτέλα Προϊόντος / Υπηρεσίας'
                            : 'Καρτέλα Μεταβολής Προϊόντος / Υπηρεσίας',
                    detail: 'Η εγγραφή καταχωρήθηκε επιτυχώς',
                    severity: 'success',
                    key: 'br'
                } as ToastMessageOptions);
                this.productVisibleDialog = false;
            });
    }
}

const productPackageQuery = ProductPackageTypeQuery.GQLQueryWith({
    ...ProductPackageTypeQuery.GQLQuery(),
    _id: true,
    Title: true,
    Code: true,
    BarCode: true,
    UnitTypeId: true,
    UnitType: ProductUnitTypeTypeQuery.GQLQueryWith({
        _id: true,
        Title: true
    }),
    // Discounts: ProductToDiscountTypeQuery.GQLQueryWith({
    //     DiscountCategoryId: true,
    //     DiscountCategory: DiscountCategoryTypeQuery.GQLQueryWith({
    //         Code: true
    //     }),
    //     ProductPackageId: true,
    //     Perentage: true
    // }),
    InventoriesList: ProductInventoryInfoTypeQuery.GQLQueryWith({
        ProductPackageId: true,
        SmallPackageItems: true,
        _id: true,
        Stock: true
    }),
    InvoicingList: ProductInvoicingInfoTypeQuery.GQLQueryWith({
        WholesalePrice: true,
        ProductPackageId: true,
        VATCategoryId: true,
        VATCategory: VATCategoryTypeQuery.GQLQueryWith({
            _id: true,
            Value: true
        })
    }),
    ProductDepartmentId: true,
    ProductDepartment: ProductDepartmentTypeQuery.GQLQuery({
        VATCategoryId: true,
        VATCategory: VATCategoryTypeQuery.GQLQuery()
    })
    // ProductPackage: ProductPackageTypeQuery.GQLQuery({
    //                       UnitType: ProductUnitTypeTypeQuery.GQLQuery(),
    //                       InvoicingList: ProductInvoicingInfoTypeQuery.GQLQuery({
    //                         VATCategory: VATCategoryTypeQuery.GQLQuery(),
    //                       }),
    //                     }),
    //                     ProductLOT: ProductLOTTypeQuery.GQLQuery(),
    //                     VATCategory: VATCategoryTypeQuery.GQLQuery(),
});
